import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex justify-content-end mx-auto" }

import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonArea',
  props: {
    modelValue: { type: Boolean },
    isDisabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const router = useRouter();

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function moveDailyReportList() {
  router.push({ name: "DailyReport" })
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      class: "reset-btn",
      onClick: moveDailyReportList
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.cancel')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      class: "exec-btn ml-4",
      disabled: props.isDisabled,
      style: _normalizeStyle({
        backgroundColor: props.isDisabled ? '#B3B8BB' : '',
      }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.confirm')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "style"])
  ]))
}
}

})